import { render, staticRenderFns } from "./GroupMemberDeleteDialogue.vue?vue&type=template&id=48c557bd&"
import script from "./GroupMemberDeleteDialogue.vue?vue&type=script&lang=js&"
export * from "./GroupMemberDeleteDialogue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports